module.exports = __webpack_public_path__ + "static/media/Tosee.4bbf6eaf.svg";